import React from 'react';

import {BioentitySummary} from 'folder-items/FileConstants';
import {CreateAndRegisterBioentityArgs} from 'registry/create-bioentity/CreateBioentityUtil';
import FindOrCreateBioentity from 'samples/transfers/input-sample/FindOrCreateBioentity';
import {TYPE as InputSampleType} from 'samples/transfers/input-sample/InputSampleConstants';
import {UpdateTransferModalStateHandler} from 'samples/transfers/TransferModalUtil';
import FormGroup from 'ui-library/bs/FormGroup';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {GenericEvent} from 'util/Types';

interface Props {
  createAndRegisterBioentityArgs: CreateAndRegisterBioentityArgs;
  inputBioentity: BioentitySummary | null;
  inputType: InputSampleType;
  onUpdateModalState: UpdateTransferModalStateHandler;
}

function ChooseInputContainable({
  createAndRegisterBioentityArgs,
  inputBioentity,
  inputType,
  onUpdateModalState,
}: Props): JSX.Element {
  function handleChangeCreateAndRegisterBioentityArgs(args: Partial<CreateAndRegisterBioentityArgs>): void {
    onUpdateModalState({createAndRegisterBioentityArgs: {...createAndRegisterBioentityArgs, ...args}});
  }

  function handleChangeInputBioentity(bioentity: BioentitySummary): void {
    onUpdateModalState({inputBioentity: bioentity});
  }

  function handleChangeInputType(e: GenericEvent): void {
    onUpdateModalState({inputType: e.target.value as InputSampleType});
  }

  return (
    <div>
      <FormGroup>
        <FieldLabel label="Entity" />
        <FindOrCreateBioentity
          createAndRegisterBioentityArgs={createAndRegisterBioentityArgs}
          inputBioentity={inputBioentity}
          inputType={inputType}
          onChangeCreateAndRegisterBioentityArgs={handleChangeCreateAndRegisterBioentityArgs}
          onChangeInputBioentity={handleChangeInputBioentity}
          onChangeInputType={handleChangeInputType}
        />
      </FormGroup>
    </div>
  );
}

export default ChooseInputContainable;
